<template>
  <div class="file-wrap">

    <template v-for="(item, index) in fileList">
      <div class="file-box">
        <div class="file-icon">
          <img :src="item.iconUrl" class="icon-img" alt="" />
          <div class="upload-error" v-if="item.percentage === -100">
            <img :src="errorUrl" alt="" />
          </div>
        </div>

        <div class="file-info">
          <span class="name-info">{{ item.name }}</span>
          <span v-if="item.percentage === 100" class="type-info">{{ item.type }} {{ formatSize(item.size) }}</span>
          <span v-else-if="item.percentage === -100" class="type-upload" @click="$emit('uploadFile', item)">重新上传</span>
          <span v-else v-loading="true" element-loading-text="上传中" class="loading-span msg-content"></span>
        </div>
        <i class="el-icon-error del-btn" v-if="item.percentage != 0 && !isMain" @click="handleDel(item)"></i>
      </div>
    </template>
  </div>
</template>

<script>
import errorIcon from "@/assets/image/chat/upload_error.png";
export default {
  data() {
    return {
      errorUrl: errorIcon,
    };
  },
  props: ["fileList", "isMain"],
  mounted() {
    // this.errorUrl = errorIcon
  },
  methods: {
    formatSize(size) {
      let coutSize = "";
      let result = size / 1024;
      if (result < 1024) {
        coutSize = Math.ceil(result) + "KB"; //向上取整
      } else if (result >= 1024) {
        coutSize = (size / (1024 * 1024)).toFixed(2) + "M"; //四舍五入
      }
      return coutSize;
    },
    handleDel(item) {
      this.$emit("delFile", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.file-wrap {
  margin-top: 1rem;
  margin-left: 1rem;
  display: flex;
  flex-wrap: wrap;

  .file-box {
    position: relative;
    display: flex;
    width: 15rem;
    // min-width: 12rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
    padding: 0.8rem;
    background-color: rgba(179, 188, 205, 0.2);
    border-radius: 10px;

    .del-btn {
      position: absolute;
      height: 1.8rem;
      width: 1.8rem;
      right: -12px;
      top: -5px;
      cursor: pointer;
      color: #626262;
      opacity: 0.8;

      &:hover {
        color: #000;
      }
    }

    .file-icon {
      position: relative;
      display: flex;
      width: 2.5rem;
      height: 2.5rem;
      justify-content: center;
      align-items: center;
      border-radius: 10px;

      .icon-img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
    }

    .upload-error {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      width: 2.5rem;
      height: 2.5rem;
      top: 0;
      left: 0;
      background-color: #1e1515;
      opacity: .8;
      border-radius: 10px;

      img {
        width: 50%;
        height: 50%;
      }
    }

    .file-info {
      width: calc(100% - 3.5rem);
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .type-info {
        color: #838a95;
        text-align: left;
      }

      .type-upload {
        text-align: left;
        color: #409eff;
        cursor: pointer;
      }

      .name-info {
        flex: 1;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      ::v-deep .el-loading-spinner {
        display: flex;
        color: #666;
        text-align: left;

        .circular {
          margin-top: 3px;
          width: 1.2rem;
          height: 1.2rem;
        }

        .el-loading-text {
          margin-left: 10px;
        }
      }
    }
  }
}

@media (max-width:1023px) {
  * {
    font-size: $font_size;
  }

  .file-wrap {
    aria-hidden: false !important;
    padding: 12px 0;
    /* 增加点击热区 */
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    /* 移除点击高光 */

    @media (hover: none) {
      /* 移动端专属优化 */
      font-size: 16px;
      /* 增加可点击区域 */
      min-height: 48px;
      /* Material Design 推荐最小点击尺寸 */
    }

    margin-top: 0.1rem;
    margin-left: 0.1rem;

    .file-box {
      width: 28%;
      margin-right: 0.1rem;
      margin-bottom: 0.1rem;
      padding: 0.1rem;

      .del-btn {
        height: auto;
        width: auto;
        right: -2px;
      }

      .file-icon {
        width: 0.35rem;
        height: 0.35rem;
      }

      .upload-error {
        width: 0.25rem;
        height: 0.25rem;

      }

      .file-info {
        width: calc(100% - 0.32rem);

        ::v-deep .el-loading-spinner {
          .circular {
            margin-top: 3px;
            width: 0.18rem;
            height: 0.18rem;
          }
        }
      }
    }
  }
}
</style>